import type { Person, State } from './types';

export type Mutation =
  | {
      type: 'setPeople';
      data: Person[];
      count?: number;
      merge?: boolean;
      offset?: number;
    }
  | { type: 'updatePerson'; item: Person }
  | { type: 'addPerson'; item: Person };

export function reducer(state: State, action: Mutation): State {
  switch (action.type) {
    case 'setPeople':
      return setPeople(state, action);
    case 'updatePerson':
      return updatePerson(state, action);
    case 'addPerson':
      return addPerson(state, action);
    default:
      return state;
  }
}

function setPeople(
  state: State,
  {
    data,
    count,
    merge,
  }: {
    data: Person[];
    count?: number;
    merge?: boolean;
  },
): State {
  const items: Person[] = !merge ? data : state.data.concat(data);

  return {
    data: items,
    loaded: true,
    count: count || state.count || 0,
  };
}

function updatePerson(state: State, { item }: { item: Person }): State {
  const index = state.data.findIndex((person) => person.id === item.id);
  if (index !== -1) {
    const data = [...state.data];
    data[index] = {
      id: item.id,
      data: {
        ...state.data[index].data,
        ...item.data,
      },
    };

    return {
      ...state,
      data,
    };
  }

  return state;
}

function addPerson(state: State, { item }: { item: Person }): State {
  return {
    ...state,
    data: [...state.data, item],
  };
}
